import React from 'react';
import CoreThemeProvider, { Theme } from '@nexus/lib-react/dist/theme/CoreTheme/CoreThemeProvider';
import wrappedTheme from './wrappedTheme';

const ThemeProvider: React.FC<{
  children: React.ReactNode;
}> = function ThemeProvider({ children }) {
  const theme = wrappedTheme as unknown as Theme;
  return <CoreThemeProvider theme={theme}>{children}</CoreThemeProvider>;
};

export default React.memo(ThemeProvider);
